var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_7743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2466 0H10.5664C10.1585 0 9.82793 0.337508 9.82793 0.753927C9.82793 1.17035 10.1585 1.50785 10.5664 1.50785H13.4638L6.38277 8.73717C6.09436 9.03162 6.09436 9.50894 6.38277 9.80339C6.52701 9.95058 6.71598 10.0242 6.90494 10.0242C7.0939 10.0242 7.28287 9.95058 7.42711 9.80339L14.5081 2.57407V5.53223C14.5081 5.94865 14.8387 6.28616 15.2466 6.28616C15.6545 6.28616 15.9851 5.94865 15.9851 5.53223V0.75401C15.9851 0.337508 15.6545 0 15.2466 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2256 6.28607C11.8178 6.28607 11.4872 6.62358 11.4872 7.04V14.4499H1.47692V4.23003H9.17153C9.5794 4.23003 9.90999 3.89252 9.90999 3.4761C9.90999 3.05969 9.5794 2.72218 9.17153 2.72218H0.738462C0.330585 2.72218 0 3.05969 0 3.4761V15.2039C0 15.6203 0.330585 15.9578 0.738462 15.9578H12.2256C12.6335 15.9578 12.9641 15.6203 12.9641 15.2039V7.04C12.9641 6.62358 12.6335 6.28607 12.2256 6.28607Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_7743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.84d44a7816544a58c87d3383376ed450.svg";
export { ForwardRef as ReactComponent };